import React, { useCallback } from 'react';
import Icon, { ICON_NAME } from "../../../../../../components/Icon";
import { ACTION_TYPE, OP_STATUS, OPERATION_TYPE } from "../../../../../../util/varibles/constants";
import EventView from '../../../../_components/ContentOperation/EventView';
import { IPropsOp } from "./";
import WrapperOperation from "./_components/WrapperOperation";
import styles from "./style.module.scss";

interface IProps extends IPropsOp {
    operationType: OPERATION_TYPE
    isOwn: boolean
    isVesselOwn: boolean
    permission: any
    status: OP_STATUS
}

const Event: React.FC<IProps> = (props) => {
    const { isOwn, data } = props;

    const edit = useCallback(() => {
        return {
            isShow: true,
            operationType: OPERATION_TYPE.EVENT,
            editMode: ACTION_TYPE.EDIT,
            values: data,
        }
    }, [data])

    const icon = <Icon icon={ICON_NAME.EVENT} dataAttribute={{ 'data-event-type': data.operation.event_type }} />

    return <WrapperOperation {...{ ...props, icon, edit }}>
        <div className={[styles['content-wrapper'], styles.layout].join(' ')}>
            <EventView
                status={props.status}
                data={data}
                isOwn={isOwn}
            />
        </div>
    </WrapperOperation>;
};

export default Event;